/**
 * ExchangeRate GraphQL Queries
 * Queries para obtener tipos de cambio desde la API
 */

/**
 * Consulta para obtener el tipo de cambio más reciente
 * Devuelve el tipo de cambio más reciente registrado en la base de datos
 */
export const GET_LATEST_EXCHANGE_RATE = `
  query LatestExchangeRate {
    latestExchangeRate {
      id
      exchangeDate
      sellRate
      buyRate
      closingBuyRate
      closingSellRate
      createdAt
      updatedAt
    }
  }
`;

/**
 * Consulta para obtener el tipo de cambio por fecha
 * Devuelve el tipo de cambio registrado para una fecha específica
 * Parámtero: exchangeDate (string) - Fecha en formato YYYY-MM-DD
 */
export const GET_EXCHANGE_RATE_BY_DATE = `
  query ExchangeRateByDate($exchangeDate: String!) {
    exchangeRateByDate(fecha: $exchangeDate) {
      id
      exchangeDate
      sellRate
      buyRate
      closingBuyRate
      closingSellRate
      createdAt
      updatedAt
    }
  }
`;

/**
 * Consulta para obtener tipos de cambio mensuales por año
 * Devuelve una lista con el tipo de cambio registrado para cada mes de un año específico
 * Parámetro: year (string) - Año en formato YYYY-MM-DD (se usará solo el año)
 */
export const GET_MONTHLY_EXCHANGE_RATES_BY_YEAR = `
  query ExchangeRatesByMonthYear($month: Int!, $year: Int!) {
        exchangeRatesByMonthYear(month: $month, year: $year) {
        id
        exchangeDate
        sellRate
        buyRate
        closingBuyRate
        closingSellRate
        createdAt
        updatedAt
      }
    }
`;
